import { UntypedFormArray, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export function clearFormArray(formArray: UntypedFormArray) {
   while (formArray.length !== 0) {
      formArray.removeAt(0);
   }
}

export class CustomErrorStateMatcher implements ErrorStateMatcher {
   isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const isSubmitted = form && form.submitted;
      return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
   }
}
